const parseStringFromHtml = (html) => {
  const nodeToString = (parentNode) => {
    let output = "";
    parentNode.childNodes.forEach((node) => {
      if (node.childNodes.length > 1) {
        output += nodeToString(node);
      } else if (node.nodeName === "P") {
        output += (output ? "\n" : "") + node.textContent.trim(); // Add newline between paragraphs
      } else if (node.nodeName === "BR") {
        output += "\n";
      } else {
        output += node.textContent.trim();
      }
    });
    return output;
  };


  const convertToTextWithLineBreaks = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const result = nodeToString(tempDiv);
    return result;
  };

  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  const mathFields = tempDiv.querySelectorAll("math-field");
  mathFields.forEach((mathField) => {
    const latex = mathField.textContent; // Get the latex content
    mathField.outerHTML = `\\( ${latex} \\)`;
  });

  return convertToTextWithLineBreaks(
    tempDiv.innerHTML.replace(/<\/?math-field[^>]*>/g, "")
  );
};

export default parseStringFromHtml;
